module.exports = __webpack_public_path__ + "static/media/6.c32ba5a3.svg";